<template>
    <div>
      <!-- Page content -->
      <v-card style="border-radius: 10px">
        <v-card-title style="color: #595959">
          <v-row>
            <v-col class="py-2">{{ $t("title.Innovation") }}</v-col>
            <v-spacer />
            <v-btn
              small
              class="ma-2 mr-4"
              elevation="0"
              outlined
              color="info"
              @click="goDetail()"
            >
              {{ $t("buttons.createInnovation") }}
            </v-btn>
          </v-row>
        </v-card-title>
  
        <v-divider />
  
        <v-card-text class="pt-4"
          ><v-row justify="space-between">
            <v-col cols="2">
              <v-select
                v-model="itemsPerPage"
                :items="perPageValues"
                :label="$t('labels.selectItemsPerPage')"
                item-value="value"
                item-text="name"
                @change="changeItemsPerPage()"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loadings.table"
            :options.sync="options"
            :hide-default-footer="true"
            :footer-props="{
              disablePagination: true,
              disableItemsPerPage: true,
            }"
            :no-data-text="$t('description.noList')"
          >
            <!-- eslint-disable -->
            
            <template v-slot:item.EndDate="{ item }">
            {{ convertToLocal(item.EndDate) }}
          </template>
            <template v-slot:item.IsPrimacy="{ item }">
              <v-chip
                v-if="item.IsPrimacy == false"
                class="ma-2"
                small
                color="green"
                text-color="white"
              >
                {{ $t("labels.public") }}
              </v-chip>
              <v-chip
                v-if="item.IsPrimacy == true"
                class="ma-2"
                small
                color="orange"
                text-color="white"
              >
                {{ $t("labels.anonim") }}
              </v-chip>
              
            </template>
  
            <template v-slot:item.actions="{ item }">
              <v-tooltip top v-if="item.TopTen.length!=0">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="openTopList(item.Id)"
                    v-bind="attrs"
                    v-on="on"
                  >
                  mdi-eye
                  </v-icon>
                </template>
                <span>{{ $t("labels.seeTopList") }}</span>
              </v-tooltip>
              <v-tooltip  top v-if="item.TopTen.length==0">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="giveScoreToUsers(item.Id)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-window-close
                  </v-icon>
                </template>
                <span>{{ $t("labels.finishInovation") }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="goDetail(item.Id)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>{{ $t("labels.tooltipEdit") }}</span>
              </v-tooltip>
              
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2 md4 lg4">
            <v-pagination
              @input="paginationChangeHandler"
              :value="pagination.page"
              :length="pages"
              :total-visible="10"
              circle
            ></v-pagination>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </template>
  
  <script>
  import InnovationService from "../services/InnovationService";
  import DeleteModal from "../components/General/DeleteModal";
  import BadgeService from "../services/BadgeService";
  import { mapActions } from "vuex";
  export default {
    data: () => ({
      // List options
      options: {
        itemsPerPage: 15,
      },
      top: 15,
      skip: 0,
      tableData: [],
      headers: [],
      //Loading states
      loadings: {
        table: false,
        select: false,
        send: false,
      },
      modalHeader: "", //Global header for opened modal
      //Group
  
      //Pagination models
      pagination: {},
      itemsPerPage: 15,
      perPageValues: [10, 15, 30, 50, 100],

  
    }),
  
    watch: {},
    mounted() {
      this.setup();
      this.getTableList();
    },
    components: {
      DeleteModal,
    },
  
    computed: {
      totalRecords() {
        return this.items.length;
      },
      pageCount() {
        return this.totalRecords / this.itemsPerPage;
      },
      pages() {
        if (
          this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) {
          return 0;
        }
  
        return Math.ceil(
          this.pagination.totalItems / this.pagination.rowsPerPage
        );
      },
    },
  
    methods: {
      setup() {
        this.headers = [
          {
            text: this.$t("title.tableHeaderName"),
            value: "Title",
            sortable: false,
          },
          {
            text: this.$t("title.tableHeaderMaxMemberCount"),
            value: "MaxMemberCount",
            sortable: false,
            align: "center",
          },
          {
            text: this.$t("title.tableHeaderScore"),
            value: "Score",
            sortable: false,
            align: "center",
          },
          {
            text: this.$t("title.tableHeaderEndDate"),
            value: "EndDate",
            sortable: false,
            align: "center",
          },
  
          {
            text: this.$t("title.tableHeaderIdeacount"),
            value: "IdeaCount",
            sortable: false,
            align: "center",
          },
          {
            text: this.$t("title.tableHeaderStatus"),
            value: "IsPrimacy",
            sortable: false,
            align: "center",
          },
          {
            text: this.$t("title.tableHeaderActions"),
            value: "actions",
            sortable: false,
            align: "center",
          },
          (this.pagination = {
            totalItems: 200,
            rowsPerPage: this.itemsPerPage,
            page: 1,
          }),
        ];
      },
      //Fill's the emergency list
      getTableList() {
        this.$store.state.loadingStatus = true;
  
        InnovationService.getInnovations(
          this.pagination.page,
          this.pagination.rowsPerPage
        )
          .then((res) => {
            this.tableData = res.data.Result;
            this.pagination.totalItems = res.data.TotalItems;
          })
          .catch((err) => {
            window.handleServiceError(res, err);
          })
          .then(() => {
            this.$store.state.loadingStatus = false;
          });
      },
  
      
      goDetail(id) {
      this.$router.push({
        name: `innovationManagement`,
        query: { id },
      });
    },
  
      getMarkerIcon(item) {
        if (item.SafetyStatus === 1)
          return require("../../public/img/PersonInDanger.png");
        else {
          return require("../../public/img/PersonNotInDanger.png");
        }
      },
  
      openMarkerInfo(item) {
        this.selectedMarker = item;
        this.markerModalShow = true;
      },
      openTopList(id){
        this.$router.push({
        name: `innovationLeaderboard`,
        query: { id },
      });
      },
      giveScoreToUsers(id){
        this.$store.state.loadingStatus = true;
        BadgeService.finishInnovation(id)
        .then((res) => {
            console.log("Download res >> ", res);
          })
          .catch((err) => {
            console.log("ERR >> ", err.Message);
            window.showError(err)
          })
          .then(() => {
            this.$store.state.loadingStatus = false;
          });
      },
  
      
      //Change displayed items per page, page number one is default
      changeItemsPerPage() {
        this.pagination.rowsPerPage = this.itemsPerPage;
        this.pagination.page = 1;
        this.options.itemsPerPage = this.itemsPerPage;
        this.getTableList();
      },
  
      //Change list pagination page
      paginationChangeHandler(pageNumber) {
        this.pagination.page = pageNumber;
        this.getTableList();
      },
    },
  };
  </script>
  